export enum TabName {
  Buy = 'buy',
  More = 'more',
  Sell = 'sell',
  Overview = 'overview',
}

type WebViewNavigateEvent = {
  eventName: 'navigate';
  eventData: {
    tabName: TabName;
    subNav?: string;
  };
};

export enum ModalScreen {
  ContactUs = 'ContactUs',
}

type WebViewModalEvent = {
  eventName: 'modal';
  eventData: {
    screenName: ModalScreen;
  };
};

type WebViewLinkEvent = {
  eventName: 'link';
  eventData: {
    href: URL;
  };
};

type WebViewEvent =
  | WebViewNavigateEvent
  | WebViewModalEvent
  | WebViewLinkEvent
  | { eventName: 'showOfferPanel' }
  | { eventName: 'showTourPanel' }
  | { eventName: 'refresh' };

const postToReactNative = (stringifiedData: string): void => {
  if (window.ReactNativeWebView) {
    /**
     * Anding a route to post message on android leads it to be being undefined for some reason
     * https://github.com/react-native-webview/react-native-webview/issues/1829
     */
    window.ReactNativeWebView.postMessage(stringifiedData);
  }
};

/** Send a message to the React Native app */
const sendWebViewEvent = (message: WebViewEvent): void => {
  const stringifiedData = JSON.stringify(message);
  postToReactNative(stringifiedData);
};

/** Tells the native app to handle the tab navigation */
export const sendWebViewNavigateEvent = (
  tabName: TabName,
  subNav?: WebViewNavigateEvent['eventData']['subNav'],
): void => sendWebViewEvent({ eventName: 'navigate', eventData: { tabName, subNav } });

/** Tells the native app to display a modal (containing either a native screen or a web view) */
export const sendWebViewModalEvent = (screenName: ModalScreen): void =>
  sendWebViewEvent({ eventName: 'modal', eventData: { screenName } });

/** Tells the native app to open an arbitrary link (e.g. in a Safari view) */
export const sendWebViewLinkEvent = (href: URL): void =>
  sendWebViewEvent({ eventName: 'link', eventData: { href } });

interface PostMessageData {
  type: WebViewEvent;
}
/**
 *
 * @param message
 * We need this method since Calendly also has a 'message' event listener setup
 * and it isn't stringified.
 * @throws only when the error isn't an `Unexpected identifier "Object" error`
 */
export const safelyParseWebviewMessage = (message: MessageEvent<string>) => {
  try {
    const parseData: PostMessageData = JSON.parse(message.data);
    return parseData;
  } catch {
    return;
  }
};
